import React from 'react';
import './Safeguarding.css';
import { safeguardingDocumentGroups } from '../data/safeguardingDocuments';

const Safeguarding: React.FC = () => {
    return (
        <div className="safeguarding-container">
            <div className="safeguarding-header">
                <h1>Safeguarding</h1>
                <div className="header-underline"></div>
            </div>

            <div className="safeguarding-content">
                <section className="officer-section">
                    <h2>Safeguarding Officer</h2>
                    <p>
                        The safety and well-being of our students is our top priority. If you have any concerns or need to speak with our safeguarding officer, please use the contact details below:
                    </p>
                    <div className="contact-card">
                        <div className="contact-item">
                            <strong>Name:</strong> Jenny Catley
                        </div>
                        <div className="contact-item">
                            <strong>Phone:</strong> 07853 209109
                        </div>
                        <div className="contact-item">
                            <strong>Email:</strong> <a href="mailto:jennyrcatley@hotmail.com">jennyrcatley@hotmail.com</a>
                        </div>
                    </div>
                </section>

                <section className="certifications-section">
                    <h2>Qualifications & Certifications</h2>
                    <ul className="cert-list">
                        <li>
                            <span className="cert-icon">✓</span>
                            <div className="cert-detail">
                                <strong>First Aid Refresher</strong>
                                <p>Renewed: January 2026</p>
                            </div>
                        </li>
                        <li>
                            <span className="cert-icon">✓</span>
                            <div className="cert-detail">
                                <strong>Enhanced DBS</strong>
                                <p>Renewed: January 2026</p>
                            </div>
                        </li>
                        <li>
                            <span className="cert-icon">✓</span>
                            <div className="cert-detail">
                                <strong>NSPCC Additional Safeguarding Course</strong>
                                <p>Completed: December 2025</p>
                            </div>
                        </li>
                    </ul>
                </section>

                <section className="policies-section">
                    <h2>Policies & Documentation</h2>
                    <p>
                        We adhere to strict safeguarding policies to ensure a safe training environment for everyone. Our full range of policies and documentation is available to download below.
                    </p>
                    {safeguardingDocumentGroups.map((group) => (
                        <div key={group.heading} className="document-group">
                            <h3>{group.heading}</h3>
                            <ul className="documents-list">
                                {group.documents.map((doc) => (
                                    <li key={doc.filename} className="document-item">
                                        <a
                                            href={`/safeguarding/${encodeURIComponent(doc.filename)}`}
                                            className="document-link"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
                                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 1.5L18.5 9H13V3.5zM6 20V4h5v7h7v9H6z"/>
                                            </svg>
                                            {doc.title}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </section>
            </div>
        </div>
    );
};

export default Safeguarding;
